export interface PeaksAndDuration {
    peaks: number[][];
    duration: number;
}

export async function generatePeaksFromAudioBuffer(
    audioBuffer: AudioBuffer,
    samplesPerChannel: number
): Promise<PeaksAndDuration> {
    const channels = audioBuffer.numberOfChannels;
    const peaks: number[][] = [];

    for (let c = 0; c < channels; c++) {
        const channelData = audioBuffer.getChannelData(c);
        const samplesPerPeak = Math.floor(channelData.length / samplesPerChannel);
        const channelPeaks: number[] = [];

        for (let i = 0; i < samplesPerChannel; i++) {
            let start = i * samplesPerPeak;
            let end = start + samplesPerPeak;
            let max = 0;

            for (let j = start; j < end && j < channelData.length; j++) {
                const value = Math.abs(channelData[j]);
                if (value > max) {
                    max = value;
                }
            }

            channelPeaks.push(max);
        }

        peaks.push(channelPeaks);
    }

    return {
        peaks,
        duration: audioBuffer.duration,
    };
}

export async function generatePeaksFromArrayBuffer(
    arrayBuffer: ArrayBuffer,
    samplesPerChannel: number = 1000,
    decodeAudioData: (arrayBuffer: ArrayBuffer) => Promise<AudioBuffer>
): Promise<PeaksAndDuration> {
    const audioBuffer = await decodeAudioData(arrayBuffer);
    return generatePeaksFromAudioBuffer(audioBuffer, samplesPerChannel);
}

export async function generatePeaksFromAudioSrcUrl(
    url: string,
    samplesPerChannel: number = 1000,
    decodeAudioData: (arrayBuffer: ArrayBuffer) => Promise<AudioBuffer>
): Promise<PeaksAndDuration> {
    const response = await fetch(url);
    const arrayBuffer = await response.arrayBuffer();
    return generatePeaksFromArrayBuffer(arrayBuffer, samplesPerChannel, decodeAudioData);
}
